import PdpLayout from "@/components/pdp/PdpLayout";
import { HYDROGEL } from "@/data/hydrogel";

export default function PdpConcept() {
  return <PdpLayout data={HYDROGEL} />;
}
